import { createTheme } from '@material-ui/core/styles';

const defaultTheme = {
  overrides: {
    MUIDataTableHeadCell: {
      root: {
        fontWeight: 600,
      },
    },
    MUIDataTableSelectCell: {
      root: {
        display: 'none',
      },
    },
    MuiButtonBase: {
      root: {
        borderRadius: '5px',
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: 0,
        paddingLeft: '8px',
      },
    },
  },
  palette: {
    primary: {
      contrastText: '#fff',
      main: '#388E3C',
    },
    secondary: {
      contrastText: '#fff',
      main: '#2AAAE2',
    },
    typography: {
      h4: '#172B4D',
      subtitle1: 'rgba(0, 0, 0, 0.38)',
    },
  },
  shadows: Array(25).fill('none'),
  typography: {
    button: {
      textTransform: 'none',
    },
    h4: {
      color: '#172B4D',
      fontSize: 30,
      fontWeight: 'bold',
    },
    h5: {
      color: '#172B4D',
      fontSize: 28,
      fontWeight: 'bold',
    },
    h6: {
      color: '#172B4D',
      fontSize: 24,
      fontWeight: 'bold',
    },
    subtitle1: {
      color: 'rgba(0, 0, 0, 0.38)',
      fontSize: '0.8rem',
      lineHeight: 1.8,
    },
  },
};
const theme = createTheme(defaultTheme);

export const updatePrimaryColor = (color) => {
  return createTheme({
    ...defaultTheme,
    palette: {
      ...defaultTheme.palette,
      primary: {
        contrastText: '#fff',
        main: color,
      },
    },
  });
};

export default theme;
